import { FilterHandlerBase } from './base/filter-handler-base';
import {
  FilterPassParams,
  DescriptionFilterType,
  FilterOptions,
  IFilterComparator,
  DoubleFilterOperator
} from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { Departement } from '../../../types/deal.types';
import { DefaultComparator } from './comparators/default-comparator';

export class IssuerFilterHandler extends FilterHandlerBase {
  get name(): string {
    return CalendarGridColumnName.Issuer;
  }

  private comparator: IFilterComparator<any>;

  protected getDataFromParams(
    params: FilterPassParams
  ): { id: string; issuer: Departement } {
    return params.deal;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    let filterPassed = true;
    const issuer = params.filters[this.name];
    const data = this.getDataFromParams(params);
    if (issuer) {
      const isDoubleIssuer = Object.prototype.hasOwnProperty.call(
        issuer.model,
        'operator'
      );
      if (isDoubleIssuer) {
        const doubleModel = issuer.model;
        const single1FilterPassed = this.filterSingleIssuerModel(
          doubleModel.condition1,
          data.issuer.name
        );
        const single2FilterPassed = this.filterSingleIssuerModel(
          doubleModel.condition2,
          data.issuer.name
        );
        if (doubleModel.operator === DoubleFilterOperator.AND) {
          filterPassed = single1FilterPassed && single2FilterPassed;
        } else if (doubleModel.operator === DoubleFilterOperator.OR) {
          filterPassed = single1FilterPassed || single2FilterPassed;
        }
      } else {
        const singleModel = issuer.model;
        filterPassed = this.filterSingleIssuerModel(
          singleModel,
          data.issuer.name
        );
      }
    }
    result.applyDealFilerResult(data.id, this.name, filterPassed);

    return filterPassed;
  }

  filterSingleIssuerModel(model, issuerName: string): boolean {
    issuerName = issuerName ? issuerName.toUpperCase() : '';
    const filter = model.filter ? model.filter.toUpperCase() : '';
    switch (model.type) {
      case DescriptionFilterType.Equals:
        return issuerName === filter;
      case DescriptionFilterType.NotEqual:
        return issuerName !== filter;
      case DescriptionFilterType.Contains:
        return issuerName.indexOf(filter) !== -1;
      case DescriptionFilterType.NotContains:
        return issuerName.indexOf(filter) === -1;
      case DescriptionFilterType.StartsWith:
        return issuerName.startsWith(filter);
      case DescriptionFilterType.EndsWith:
        return issuerName.endsWith(filter);
      default:
        return undefined;
    }
  }

  hasValidDiff(options: FilterOptions, grid: any, store: any): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(options): IFilterComparator<any> {
    if (!this.comparator) {
      this.comparator = new DefaultComparator();
    }
    this.comparator.applyFilterOptions(this.getFilterOptions(options));
    return this.comparator;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return null;
  }
}
